import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/expenseManage',
    meta: { title: '费用管理' },
    component: Layout,
    redirect: '/expenseManage/list',
    children: [
      {
        path: 'list',
        meta: { title: '费用管理', activeMenu: '/expenseManage' },
        component: () => import('@/views/expenseManage/ExpenseManage.vue')
      },
      {
        path: 'detail',
        meta: { title: '费用管理详情', activeMenu: '/expenseManage' },
        component: () => import('@/views/expenseManage/ExpenseManageDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增费用', activeMenu: '/expenseManage' },
        component: () => import('@/views/expenseManage/ExpenseManageAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑费用', activeMenu: '/expenseManage' },
        component: () => import('@/views/expenseManage/ExpenseManageAdd.vue')
      }

    ]
  }

]
